/**
 * @flow
 * @relayHash 853cdc25d4e3724ae1e0c500904e5df7
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type EditReviewsPaginator_query$ref = any;
export type CustomerNotificationSubscriptionType = "BESTSELLER" | "STEADYSELLER" | "SUDDEN_RISE" | "%future added value";
export type NewsAndReviewOrderBy = "DATE" | "DEFAULT" | "TIMESTAMP_CREATED" | "%future added value";
export type Order = "ASC" | "DEFAULT" | "DESC" | "%future added value";
export type PublishedFilter = "ANY" | "FUTURE" | "LAST_12_MONTHS" | "LAST_4_MONTHS" | "NEXT_14_DAYS" | "TODAY" | "%future added value";
export type SearchMode = "PUBLISHING_HOUSE" | "STORE" | "%future added value";
export type PublishersEditLayoutOverrideDataWrapperQueryVariables = {|
  count: number,
  cursor?: ?string,
  orderBy?: ?NewsAndReviewOrderBy,
  order?: ?Order,
  search?: ?string,
  filterBy?: ?$ReadOnlyArray<string>,
  titleIds?: ?$ReadOnlyArray<string>,
  includeNews?: ?boolean,
  includeReviews?: ?boolean,
  includeGeneralMessages?: ?boolean,
  mode: SearchMode,
  onlyFavorites: boolean,
  excludeDigital?: ?boolean,
  excludeUnavailable?: ?boolean,
  published?: ?PublishedFilter,
  onlyWithNotificationTypes?: ?$ReadOnlyArray<CustomerNotificationSubscriptionType>,
  includeTitles: boolean,
|};
export type PublishersEditLayoutOverrideDataWrapperQueryResponse = {|
  +titles?: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +title: string,
        +authors: ?$ReadOnlyArray<{|
          +name: string
        |}>,
        +publishingHouses: ?$ReadOnlyArray<{|
          +name: string
        |}>,
        +coverImage: ?{|
          +sizes: ?$ReadOnlyArray<{|
            +name: string,
            +url: string,
          |}>,
          +id: string,
        |},
      |}
    |}>
  |},
  +viewer: {|
    +group: ?{|
      +type: string,
      +publishingHouseIds: ?$ReadOnlyArray<?string>,
    |},
    +id: string,
    +isSuperAdmin: boolean,
    +isAdministrator: boolean,
  |},
  +$fragmentRefs: EditReviewsPaginator_query$ref,
|};
export type PublishersEditLayoutOverrideDataWrapperQuery = {|
  variables: PublishersEditLayoutOverrideDataWrapperQueryVariables,
  response: PublishersEditLayoutOverrideDataWrapperQueryResponse,
|};
*/


/*
query PublishersEditLayoutOverrideDataWrapperQuery(
  $count: Int!
  $cursor: String
  $orderBy: NewsAndReviewOrderBy
  $order: Order
  $search: String
  $filterBy: [ID!]
  $titleIds: [ID!]
  $includeNews: Boolean
  $includeReviews: Boolean
  $includeGeneralMessages: Boolean
  $mode: SearchMode!
  $onlyFavorites: Boolean!
  $excludeDigital: Boolean
  $excludeUnavailable: Boolean
  $published: PublishedFilter
  $onlyWithNotificationTypes: [CustomerNotificationSubscriptionType!]
  $includeTitles: Boolean!
) {
  titles(first: $count, after: $cursor, search: $search, filterBy: $titleIds, published: $published, excludeDigital: $excludeDigital, excludeUnavailable: $excludeUnavailable, mode: $mode, onlyFavorites: $onlyFavorites, onlyWithNotificationTypes: $onlyWithNotificationTypes) @include(if: $includeTitles) {
    edges {
      node {
        id
        title
        authors {
          name
          id
        }
        publishingHouses {
          name
          id
        }
        coverImage {
          sizes {
            name
            url
          }
          id
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ...EditReviewsPaginator_query_1aX1Zz
  viewer {
    group {
      type
      publishingHouseIds
      id
    }
    id
    isSuperAdmin
    isAdministrator
  }
}

fragment EditReviewsPaginator_query_1aX1Zz on Query {
  newsAndReviews(first: 25, orderBy: $orderBy, order: $order, search: $search, filterBy: $filterBy, includeNews: $includeNews, includeReviews: $includeReviews, includeGeneralMessages: $includeGeneralMessages, mode: $mode, onlyFavorites: $onlyFavorites) {
    totalCount
    edges {
      node {
        __typename
        ... on Review {
          id
          headline
          summaryHeadline
          underHeading
          content
          originalContent
          quotes
          date
          grade
          gradeNormalized
          url
          quotesCreatedBy {
            email
            id
          }
          createdBy {
            id
            isSuperAdmin
            isAdministrator
            name
          }
          gradingScale {
            min
            max
            symbol
            precision
          }
          media {
            id
            name
            initials
            colorClass
            limitOriginalContentDisplay
            url
            mediaType {
              id
            }
          }
          reviewer {
            id
            firstName
            lastName
          }
          referencedTitles {
            id
            title
            hasMoreAuthors
            datePublishedFirst
            yearPublishedFirst
            authors {
              id
              name
            }
            publishingHouses {
              id
              name
            }
            coverImage {
              sizes {
                name
                url
              }
              id
            }
            publications {
              format
              isbn13
              isDigital
              availability
              id
            }
          }
        }
        ... on Node {
          id
        }
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  viewer {
    id
    isAdministrator
    isSuperAdmin
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "orderBy",
    "type": "NewsAndReviewOrderBy",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "order",
    "type": "Order",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "filterBy",
    "type": "[ID!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "titleIds",
    "type": "[ID!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "includeNews",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "includeReviews",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "includeGeneralMessages",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "mode",
    "type": "SearchMode!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "onlyFavorites",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "excludeDigital",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "excludeUnavailable",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "published",
    "type": "PublishedFilter",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "onlyWithNotificationTypes",
    "type": "[CustomerNotificationSubscriptionType!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "includeTitles",
    "type": "Boolean!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "publishingHouseIds",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isSuperAdmin",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isAdministrator",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "Variable",
  "name": "excludeDigital",
  "variableName": "excludeDigital"
},
v7 = {
  "kind": "Variable",
  "name": "excludeUnavailable",
  "variableName": "excludeUnavailable"
},
v8 = {
  "kind": "Variable",
  "name": "filterBy",
  "variableName": "titleIds"
},
v9 = {
  "kind": "Variable",
  "name": "mode",
  "variableName": "mode"
},
v10 = {
  "kind": "Variable",
  "name": "onlyFavorites",
  "variableName": "onlyFavorites"
},
v11 = {
  "kind": "Variable",
  "name": "onlyWithNotificationTypes",
  "variableName": "onlyWithNotificationTypes"
},
v12 = {
  "kind": "Variable",
  "name": "published",
  "variableName": "published"
},
v13 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v16 = [
  (v15/*: any*/)
],
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "coverImage",
  "storageKey": null,
  "args": null,
  "concreteType": "PublicationCoverImage",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "sizes",
      "storageKey": null,
      "args": null,
      "concreteType": "PublicationCoverImageSize",
      "plural": true,
      "selections": [
        (v15/*: any*/),
        (v17/*: any*/)
      ]
    },
    (v3/*: any*/)
  ]
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
},
v22 = {
  "kind": "Variable",
  "name": "filterBy",
  "variableName": "filterBy"
},
v23 = {
  "kind": "Variable",
  "name": "includeGeneralMessages",
  "variableName": "includeGeneralMessages"
},
v24 = {
  "kind": "Variable",
  "name": "includeNews",
  "variableName": "includeNews"
},
v25 = {
  "kind": "Variable",
  "name": "includeReviews",
  "variableName": "includeReviews"
},
v26 = {
  "kind": "Variable",
  "name": "order",
  "variableName": "order"
},
v27 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v28 = [
  (v22/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 25
  },
  (v23/*: any*/),
  (v24/*: any*/),
  (v25/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v26/*: any*/),
  (v27/*: any*/),
  (v13/*: any*/)
],
v29 = [
  (v3/*: any*/),
  (v15/*: any*/)
],
v30 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/)
],
v31 = [
  (v15/*: any*/),
  (v3/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PublishersEditLayoutOverrideDataWrapperQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Customer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "group",
            "storageKey": null,
            "args": null,
            "concreteType": "CustomerGroup",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ]
          },
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ]
      },
      {
        "kind": "Condition",
        "passingValue": true,
        "condition": "includeTitles",
        "selections": [
          {
            "kind": "LinkedField",
            "alias": "titles",
            "name": "__PublishersEditLayoutOverride_titles_connection",
            "storageKey": null,
            "args": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/)
            ],
            "concreteType": "TitleConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "TitleEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Title",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v14/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "authors",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Entity",
                        "plural": true,
                        "selections": (v16/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "publishingHouses",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PublishingHouse",
                        "plural": true,
                        "selections": (v16/*: any*/)
                      },
                      (v18/*: any*/),
                      (v19/*: any*/)
                    ]
                  },
                  (v20/*: any*/)
                ]
              },
              (v21/*: any*/)
            ]
          }
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "EditReviewsPaginator_query",
        "args": [
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v26/*: any*/),
          (v27/*: any*/),
          (v13/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PublishersEditLayoutOverrideDataWrapperQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "newsAndReviews",
        "storageKey": null,
        "args": (v28/*: any*/),
        "concreteType": "NewsAndReviewConnection",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "totalCount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "NewsAndReviewEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "type": "Review",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "headline",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "summaryHeadline",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "underHeading",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "content",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "originalContent",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "quotes",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "date",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "grade",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "gradeNormalized",
                        "args": null,
                        "storageKey": null
                      },
                      (v17/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "quotesCreatedBy",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Customer",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "email",
                            "args": null,
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "createdBy",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Customer",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v15/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "gradingScale",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "GradingScale",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "min",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "max",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "symbol",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "precision",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "media",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Media",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v15/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "initials",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "colorClass",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "limitOriginalContentDisplay",
                            "args": null,
                            "storageKey": null
                          },
                          (v17/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "mediaType",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "MediaType",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "reviewer",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Reviewer",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "firstName",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "lastName",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "referencedTitles",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Title",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v14/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "hasMoreAuthors",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "datePublishedFirst",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "yearPublishedFirst",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "authors",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Entity",
                            "plural": true,
                            "selections": (v29/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "publishingHouses",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PublishingHouse",
                            "plural": true,
                            "selections": (v29/*: any*/)
                          },
                          (v18/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "publications",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Publication",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "format",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "isbn13",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "isDigital",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "availability",
                                "args": null,
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v20/*: any*/)
            ]
          },
          (v21/*: any*/)
        ]
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "newsAndReviews",
        "args": (v28/*: any*/),
        "handle": "connection",
        "key": "EditReviewsPaginator_newsAndReviews",
        "filters": [
          "orderBy",
          "order",
          "search",
          "filterBy",
          "includeNews",
          "includeReviews",
          "includeGeneralMessages",
          "mode",
          "onlyFavorites"
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Customer",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v5/*: any*/),
          (v4/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "group",
            "storageKey": null,
            "args": null,
            "concreteType": "CustomerGroup",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      },
      {
        "kind": "Condition",
        "passingValue": true,
        "condition": "includeTitles",
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "titles",
            "storageKey": null,
            "args": (v30/*: any*/),
            "concreteType": "TitleConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "TitleEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Title",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v14/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "authors",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Entity",
                        "plural": true,
                        "selections": (v31/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "publishingHouses",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PublishingHouse",
                        "plural": true,
                        "selections": (v31/*: any*/)
                      },
                      (v18/*: any*/),
                      (v19/*: any*/)
                    ]
                  },
                  (v20/*: any*/)
                ]
              },
              (v21/*: any*/)
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "titles",
            "args": (v30/*: any*/),
            "handle": "connection",
            "key": "PublishersEditLayoutOverride_titles",
            "filters": [
              "search",
              "filterBy",
              "published",
              "excludeDigital",
              "excludeUnavailable",
              "mode",
              "onlyFavorites",
              "onlyWithNotificationTypes"
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "PublishersEditLayoutOverrideDataWrapperQuery",
    "id": null,
    "text": "query PublishersEditLayoutOverrideDataWrapperQuery(\n  $count: Int!\n  $cursor: String\n  $orderBy: NewsAndReviewOrderBy\n  $order: Order\n  $search: String\n  $filterBy: [ID!]\n  $titleIds: [ID!]\n  $includeNews: Boolean\n  $includeReviews: Boolean\n  $includeGeneralMessages: Boolean\n  $mode: SearchMode!\n  $onlyFavorites: Boolean!\n  $excludeDigital: Boolean\n  $excludeUnavailable: Boolean\n  $published: PublishedFilter\n  $onlyWithNotificationTypes: [CustomerNotificationSubscriptionType!]\n  $includeTitles: Boolean!\n) {\n  titles(first: $count, after: $cursor, search: $search, filterBy: $titleIds, published: $published, excludeDigital: $excludeDigital, excludeUnavailable: $excludeUnavailable, mode: $mode, onlyFavorites: $onlyFavorites, onlyWithNotificationTypes: $onlyWithNotificationTypes) @include(if: $includeTitles) {\n    edges {\n      node {\n        id\n        title\n        authors {\n          name\n          id\n        }\n        publishingHouses {\n          name\n          id\n        }\n        coverImage {\n          sizes {\n            name\n            url\n          }\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...EditReviewsPaginator_query_1aX1Zz\n  viewer {\n    group {\n      type\n      publishingHouseIds\n      id\n    }\n    id\n    isSuperAdmin\n    isAdministrator\n  }\n}\n\nfragment EditReviewsPaginator_query_1aX1Zz on Query {\n  newsAndReviews(first: 25, orderBy: $orderBy, order: $order, search: $search, filterBy: $filterBy, includeNews: $includeNews, includeReviews: $includeReviews, includeGeneralMessages: $includeGeneralMessages, mode: $mode, onlyFavorites: $onlyFavorites) {\n    totalCount\n    edges {\n      node {\n        __typename\n        ... on Review {\n          id\n          headline\n          summaryHeadline\n          underHeading\n          content\n          originalContent\n          quotes\n          date\n          grade\n          gradeNormalized\n          url\n          quotesCreatedBy {\n            email\n            id\n          }\n          createdBy {\n            id\n            isSuperAdmin\n            isAdministrator\n            name\n          }\n          gradingScale {\n            min\n            max\n            symbol\n            precision\n          }\n          media {\n            id\n            name\n            initials\n            colorClass\n            limitOriginalContentDisplay\n            url\n            mediaType {\n              id\n            }\n          }\n          reviewer {\n            id\n            firstName\n            lastName\n          }\n          referencedTitles {\n            id\n            title\n            hasMoreAuthors\n            datePublishedFirst\n            yearPublishedFirst\n            authors {\n              id\n              name\n            }\n            publishingHouses {\n              id\n              name\n            }\n            coverImage {\n              sizes {\n                name\n                url\n              }\n              id\n            }\n            publications {\n              format\n              isbn13\n              isDigital\n              availability\n              id\n            }\n          }\n        }\n        ... on Node {\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  viewer {\n    id\n    isAdministrator\n    isSuperAdmin\n  }\n}\n",
    "metadata": {
      "connection": [
        {
          "count": "count",
          "cursor": "cursor",
          "direction": "forward",
          "path": [
            "titles"
          ]
        }
      ]
    }
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a86180f1ec4231bff9351f5969c45eb8';
module.exports = node;
